import * as React from "react";
import { FunctionComponent, MouseEvent } from "react";
import IconButton from "Components/Buttons/IconButton";
import { ArrowDownward } from "@mui/icons-material";

interface DownloadDataButtonProps {
    color?: "inherit" | "primary" | "secondary" | "action" | "disabled" | "error";
    isDisabled?: boolean;
    isProhibited?: boolean;
    onClick(event?: MouseEvent): void;
    className?: string;
}

const DownloadDataButton: FunctionComponent<DownloadDataButtonProps> = ({ color, isDisabled, isProhibited, onClick, className }) => (
    <IconButton
        icon={<ArrowDownward color={color} />}
        isDisabled={isDisabled}
        isProhibited={isProhibited}
        onClick={event => onClick(event)}
        className={className}
    />
);

export default DownloadDataButton;
